// extracted by mini-css-extract-plugin
module.exports =  {"root":"G77opEU5SfC01_eWnxQi","flavorDescription":"fPkJZPh7zPxAEiojR3LX","map":"XpfRNMkUxTFsh71eGArx","link":"WkwSc4CgQNmTG_nVL2hG","time":"UdL70KOx3DvFRIG_2YxW"};